import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useFactoring } from "../FactoringProvider";

export default function FactoringReset() {
  const navigate = useNavigate();

  const { reset } = useFactoring();

  useEffect(() => {
    reset();
    navigate("/mypage");
  }, []);

  return <></>;
}
